import { render, staticRenderFns } from "./AuroraHeader.vue?vue&type=template&id=35f504e1"
import script from "./AuroraHeader.vue?vue&type=script&lang=js"
export * from "./AuroraHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports